//This file contains the filters object used by the notes section 
//and the methods that act upon it.

//The filters object.
const filters = {
    searchText: '',
    sortBy: 'byEdited' // or 'byCreated' or 'alphabetical'
};

//Function to get filters.
const getFilters = () => filters;

//Function to update filters. The only parameter is an object 
//that can have the fields searchText and sortBy. If present,
//they indicate that that note field is to be updated.
const updateFilters = (updates) => {
    //Update search text if given.
    if (typeof updates.searchText === 'string') {
        filters.searchText = updates.searchText;
    }

    //Update sort method if given.
    if (typeof updates.sortBy === 'string') {
        filters.sortBy = updates.sortBy;
    }
}

//Export functions.
export {getFilters, updateFilters};